module.exports = __webpack_public_path__ + "img/telefoon-icon-compleet.90630868f26b5ff332edb5a665df380b.svg";